import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { applySeo } from '../lib/seo';
import { TOOLS } from '../lib/tools';

// Tool links use the shared registry titles; the other popular pages follow them.
const QUICK_LINKS = [
  ...TOOLS.map(({ to, title }) => ({ to, label: title })),
  { to: '/posts', label: 'Posts' },
  { to: '/cap', label: 'Cap' },
];

function NotFound() {
  const { pathname } = useLocation();

  useEffect(() => {
    applySeo({
      title: 'Page Not Found',
      description: 'The requested FlightFormula page could not be found.',
      robots: 'noindex,follow',
      // Owning the real path stops the layout's route defaults replacing this title and noindex.
      canonicalPath: pathname,
    });
  }, [pathname]);

  return (
    <div className="ff-page ff-not-found">
      <header className="ff-section-header ff-section-header--page ff-not-found__header">
        <div className="ff-section-header__copy ff-not-found__copy">
          <h1 className="ff-section-header__title ff-not-found__title">Page not found</h1>
          <p className="ff-section-header__lead ff-not-found__lead">
            There’s nothing at <code className="ff-not-found__path">{pathname}</code>. The page may have moved,
            or the address may have a typo.
          </p>
          <div className="ff-not-found__actions">
            <Link to="/" className="ff-button">
              Go to the home page
            </Link>
            <Link to="/contact" className="ff-button-ghost">
              Report a broken link
            </Link>
          </div>
        </div>
      </header>

      <section className="ff-page__section" aria-labelledby="ff-not-found-links-title">
        <div className="ff-page__section-head">
          <div>
            <h2 id="ff-not-found-links-title" className="ff-page__section-title ff-home-section-title">
              Popular pages
            </h2>
          </div>
        </div>
        <ul className="ff-tool-quick-links" aria-label="Popular pages">
          {QUICK_LINKS.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className="ff-tool-quick-link">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default NotFound;
